import React from 'react';
import { SignupEmailSection, TitleArea, FieldWrapper,EmailWrapper, EmailCodeWrapper, EmailInputWrapper, EmailInputBlock, InputStyle, ValidateBtn, DeleteButton, DeleteIcon, ErrorBlock, ErrorIcon, ErrorMessage, ResendEmailCodeWrapper, ResendEmailCodeBtn } from './style';
import warningIcon from 'images/warning.png';
import cancelIcon from 'images/icon/close_btn_grey_circle-18x18.png'

const SignupCompanyEmailScene = ({onEmailChange, onCodeChange, onAuthReq, email, emailCode,  errorMsg}) => {
    const errorClassName = errorMsg ? 'error_active' : null;
    return (
        <SignupEmailSection>
            <TitleArea>{'기업 이메일 주소를\n입력해 주세요 :)'}</TitleArea>
            <FieldWrapper>
                <EmailWrapper>
                    <EmailInputWrapper>
                        <EmailInputBlock>
                            <InputStyle className={errorClassName} type='email' onChange={(e)=>{if(onEmailChange)onEmailChange(e.target.value);}} value={email} placeholder='이메일 주소 입력' />
                            {email.length >= 2 ? (
                                <DeleteButton onClick={() => {if(onEmailChange) onEmailChange('')}}>
                                    <DeleteIcon src={cancelIcon} />
                                </DeleteButton>
                            ) : null}
                        </EmailInputBlock>
                    </EmailInputWrapper>
                    <ValidateBtn onClick={()=>{if(onAuthReq)onAuthReq();}}>인증하기</ValidateBtn>
                </EmailWrapper>
                <ErrorBlock>
                    {errorMsg ? (
                            <>
                            <ErrorIcon src={warningIcon}/>
                            <ErrorMessage>{errorMsg}</ErrorMessage>
                            </>
                    ) : null}
                </ErrorBlock>
            </FieldWrapper> 
            <FieldWrapper>
                <EmailCodeWrapper>
                    <InputStyle type='text' onChange={(e)=>{if(onCodeChange)onCodeChange(e.target.value);}} maxLength={6} value={emailCode} placeholder='인증 번호 입력' />
                </EmailCodeWrapper>
            </FieldWrapper>
            <FieldWrapper>
                <ResendEmailCodeWrapper>
                <ResendEmailCodeBtn onClick={()=>{if(onAuthReq)onAuthReq();}}>인증번호 재발송</ResendEmailCodeBtn>
                </ResendEmailCodeWrapper>
            </FieldWrapper>
        </SignupEmailSection>
    );
}

export default SignupCompanyEmailScene;